import react from "react";
import reactDom from "react-dom";
import App from './components/App.js';

reactDom.render(<App />,document.querySelector('#root'));
